import { render, staticRenderFns } from "./AppFullImage.vue?vue&type=template&id=61502e2b&scoped=true"
import script from "./AppFullImage.vue?vue&type=script&lang=js"
export * from "./AppFullImage.vue?vue&type=script&lang=js"
import style0 from "./AppFullImage.vue?vue&type=style&index=0&id=61502e2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61502e2b",
  null
  
)

export default component.exports